var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "control" },
      [
        _c("v-jsoneditor", {
          attrs: { plus: false, height: "600px", options: _vm.options },
          on: { error: _vm.onError },
          model: {
            value: _vm.myValue,
            callback: function ($$v) {
              _vm.myValue = $$v
            },
            expression: "myValue",
          },
        }),
      ],
      1
    ),
    _vm.jsonError
      ? _c("pre", { staticClass: "help is-danger" }, [
          _vm._v(_vm._s(_vm.jsonError)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }